import { IProductsState } from '@/@types'
import CONSTANTS from '@/constants'

const state: IProductsState = {
  passTypes: [],
  availablePlans: [],
  availableCertifications: [],
  availableLiveVirtualTrainings: [],
  liveVirtualTrainingDiscount: 0,
  availableBootcamps: [],
  selectedProductType: 'Subscriptions',
  planCodes: Object.values(CONSTANTS.PLANS),
  isOnePlanAvailable: false,
}

export default state
